import React from 'react'
import './Index.css'
import mob from "../../../assets/jpg/mob.png"
import white from "../../../assets/jpg/white1.png"
//import white1 from "../../../assets/jpg/white1.png"

import download from "../../../assets/jpg/download.png"
import focus from "../../../assets/jpg/dev.png"




const Index = () => {
    return (
        <div className=" steps pb-5" >
            <div className="text-white pt-3 pb-3 text-center heading">
                <p>Follow these steps to download</p>
            </div>
            <div className="clearifx  d-none d-sm-none d-md-flex justify-content-center " >
                <div className=" ms-md-5 d-flex me-md-auto ml-auto col-md-6 Box " >
                    <img className="img-fluid mob  ml-auto mr-auto mt-3" alt="d" src={mob} />
                    <img className="img-fluid white " alt="d" src={white} />
                     <div className="info text-white " >
                        <h3 className="fw-bold" style={{color: "#EE1456"}} >STEP 1</h3>
                        <p>
                            Tap “OK” to complete the download.<br />
                            Star Hunt App is 100% safe and secure.
                        </p>
                     </div>
                     
                </div>
            </div>

            {/* mobile view */}
            <div className="step1 d-block d-md-none ">
                <div className="text-white mt-5 text-center mr-auto ml-auto mt-3" >
                    <h3 className="fw-bold" style={{color: "#EE1456"}} >STEP 1</h3>
                    <p>
                        Star Hunt App is 100% safe and secure.<br />
                        Tap “OK” to complete the download.
                       
                    </p>
                </div>
                <div className=" clearifx d-flex justify-content-center " >
                <div className="d-flex me-auto ms-auto col-12 col-md-6 justify-content-center Box " >
                    <img className="img-fluid mob mt-3   " alt="d" src={mob} />
                    <img className="img-fluid white " alt="d" src={white} />
                </div>

            </div>
            </div>

            <div className="clearifx mt-5  d-none d-sm-none d-md-block  " >
                <div className=" ms-md-auto me-md-auto d-flex  ml-auto col-md-6 Box " >
                    <div className="info2 text-white mt-0 me-auto mr-auto d-block " >
                            <h3 className="fw-bold" style={{color: "#EE1456"}} >STEP 2</h3>
                           <p>
                                Wait for download to finish currently<br />
                                supported android 4.4 and above
                            </p>
                    </div>
                    <img className="img-fluid mob  ms-auto mt-3" alt="d" src={mob} />
                    <img className="img-fluid  download " alt="d" src={download} />
                    
                     
                </div>
            </div>

            {/* mobile view */}
            <div className="step2 d-block d-md-none ">
                <div className="text-white mt-5 text-center mr-auto ml-auto mt-3" >
                    <h3 className="fw-bold" style={{color: "#EE1456"}} >STEP 2</h3>
                    <p>
                        Wait for download to finish currently<br />
                        supported android 4.4 and above
                    </p>
                </div>
                <div className=" clearifx d-flex justify-content-center " >
                <div className="d-flex me-auto ms-auto col-12 col-md-6 justify-content-center   Box " >
                    <img className="img-fluid mob mt-3   " alt="d" src={mob} />
                    <img className="img-fluid download " alt="d" src={download} />
                </div>

            </div>
            </div>

            <div className="clearifx mt-5  d-none d-sm-none d-md-flex justify-content-center " >
                <div className=" ms-md-5 d-flex me-md-auto ml-auto col-md-6 Box " >
                    <img className="img-fluid mob  ml-auto mr-auto mt-3" alt="d" src={mob} />
                    <img className="img-fluid focus " alt="d" src={focus} />
                     <div className="info3 text-white " >
                        <h3 className="fw-bold" style={{color: "#EE1456"}} >STEP 3</h3>
                        <p>
                        Open settings and turn on unknown <br />
                        sources to install the Star Hunt app
                        </p>
                     </div>
                     
                </div>
            </div>

            {/* mobile view */}
            <div className="step2 d-block d-md-none ">
                <div className="text-white mt-5 text-center mr-auto ml-auto mt-3" >
                    <h3 className="fw-bold" style={{color: "#EE1456"}} >STEP 3</h3>
                    <p>
                         Open settings and turn on unknown <br />
                        sources to install the Star Hunt app
                    </p>
                </div>
                <div className=" clearifx d-flex justify-content-center " >
                <div className="d-flex me-auto ms-auto col-12 col-md-6 justify-content-center   Box " >
                    <img className="img-fluid mob mt-3   " alt="d" src={mob} />
                    <img className="img-fluid focus " alt="d" src={focus} />
                </div>

            </div>
            </div>

        </div>
    )
}

export default Index
